// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--3-LX4","container":"a10a3f92e9--container--2x-Z9","tooltip":"a10a3f92e9--tooltip--Hf5en","bargain":"a10a3f92e9--bargain--1iJVP"};